$.fn.bounce = function() {
  var $el = $(this);
  $el.addClass('bounce');
  setTimeout(function() {
    $el.removeClass('bounce');
  }, 2000);
}
